// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderCart: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 21 20" width={width} height={height}>
            <path
                fill="currentColor"
                d="M.588.875A.593.593 0 0 0 0 1.469c0 .326.265.593.588.593H1.98c.28 0 .522.197.577.475l2.164 10.688a2.36 2.36 0 0 0 2.304 1.9h11.199a.593.593 0 0 0 .588-.594.593.593 0 0 0-.588-.594H7.025c-.558 0-1.04-.397-1.154-.95l-.286-1.424H17.14c1.08 0 2.02-.743 2.282-1.8l1.543-6.224c.184-.75-.375-1.477-1.14-1.477H3.642A1.76 1.76 0 0 0 1.981.876zm3.31 2.375h15.924l-1.54 6.227a1.18 1.18 0 0 1-1.142.898H5.342zm2.275 14.547c0-.492.394-.89.881-.89s.882.398.882.89-.395.89-.882.89a.886.886 0 0 1-.881-.89m2.939 0a2.08 2.08 0 0 0-1.029-1.8 2.04 2.04 0 0 0-2.057 0 2.08 2.08 0 0 0-1.03 1.8c0 .742.393 1.428 1.03 1.8a2.04 2.04 0 0 0 2.057 0 2.08 2.08 0 0 0 1.029-1.8m7.348-.89c.487 0 .882.398.882.89s-.395.89-.882.89a.886.886 0 0 1-.882-.89c0-.492.395-.89.882-.89m0 2.968c.735 0 1.415-.396 1.782-1.04a2.1 2.1 0 0 0 0-2.077 2.05 2.05 0 0 0-1.782-1.04c-.735 0-1.414.397-1.782 1.04a2.1 2.1 0 0 0 0 2.078 2.05 2.05 0 0 0 1.782 1.039"
            />
        </svg>
    );
};

export default React.memo(HeaderCart);
